import * as React from "react";

const IconNavLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11">
            <polygon
                fill="currentColor"
                points=".003 5.305 .468 4.84 4.84 .465 5.305 0 6.232 .93 5.767 1.395 1.857 5.305 5.77 9.215 6.234 9.68 5.305 10.607 4.84 10.142 .465 5.77 0 5.305"
            />
        </svg>
    );
};

export default React.memo(IconNavLeft);
